import { render, staticRenderFns } from "./NotificationsFiles.vue?vue&type=template&id=9d74cb2c"
import script from "./NotificationsFiles.vue?vue&type=script&lang=js"
export * from "./NotificationsFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports